import React from 'react';
import './styles/app.scss';
import { Provider } from 'react-redux';
import { store } from './store/config/configureStore';

import { BrowserRouter } from 'react-router-dom';
import { theme } from './styles/theme';
import { ErrorBoundary } from './components/ErrorBoundary';
import Main from './screens/Main';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import 'moment/locale/es';
import { ThemeProvider as MuiThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider as StylesThemeProvider } from '@mui/styles';
import moment from 'moment';

 moment.locale('es');

function App() {
  return (
      <Provider store={store}>
     <StyledEngineProvider injectFirst>
           <StylesThemeProvider theme={theme}>
          <MuiThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="es">
            <BrowserRouter>
              <ErrorBoundary>
                  <CssBaseline />
               <Main />
            </ErrorBoundary>
           </BrowserRouter>
          </LocalizationProvider>
        </MuiThemeProvider>
      </StylesThemeProvider>
    </StyledEngineProvider>
</Provider>
  );
}

export default App;
